<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">Admin</h2>

      <b-row>
        <b-col>
          <Widget  title="Stats">

            <div class="d-flex border-top">
              <div class="w-50 border-right p-3 px-1">
                <div
                        class="d-flex justify-content-between align-items-center"
                >
                  <p class="text-muted mb-0 mr">
                    <router-link :to="{ name: 'CommandCenterUsersPage' }"> {{user_count}} Users</router-link>
                  </p>
                </div>

              </div>
              <div class="w-50 p-3 px-4">
                <div
                        class="d-flex justify-content-between align-items-center"
                >
                  <p class="text-muted mb-0 mr">
                    <router-link :to="{ name: 'CommandCenterCrawlsPage' }"> {{crawl_count}} Crawls</router-link>
                  </p>
                </div>
              </div>
            </div>
          </Widget>
        </b-col>
      </b-row>

      <b-row v-if="users">
        <b-col>
          <Widget
                  title="Latest Users"
          >
            <table class="table table-hover table-sm" >
              <thead>
              <tr>
                <th scope="col">Email</th>
                <th scope="col">Joined</th>
                <th scope="col">Credits</th>
              </tr>
              </thead>
              <tbody>
              <tr class="spelling" v-for="(user, index) in users">
                <td width="75%" class="link-entry"  style="vertical-align:middle">
                  <router-link :to="{ name: 'CommandCenterUserPage', params: {userid: user.id} }">{{user.email}}</router-link>
                </td>
                <td width="35%" style="vertical-align:middle">
                {{user.date_joined | moment('from')}}
                </td >
                <td  style="vertical-align:middle">
                  {{user.credits}}
               </td>
              </tr>
              </tbody>
            </table>
          </Widget>
        </b-col>
      </b-row>

      <b-row v-if="crawls">
        <b-col>
          <Widget
                  title="Latest Crawls"
          >
            <table class="table table-hover table-sm" >
              <thead>
              <tr>
                <th scope="col">Website</th>
                <th scope="col">Owner</th>
                <th scope="col">Started</th>
                <th scope="col">Pages</th>
                <th scope="col">Status</th>
                <th scope="col">Errors</th>
                <th scope="col">Preview</th>
              </tr>
              </thead>
              <tbody>
              <tr class="spelling" v-for="(crawl, index) in crawls">
                <td class="link-entry"  style="vertical-align:middle">
                  <a :href="crawl.website.url" target="_blank" rel="noreferrer">{{crawl.website.url}}</a>
                </td>
                <td>
                  <router-link :to="{ name: 'CommandCenterUserPage', params: {userid: crawl.owner.id} }">{{crawl.owner.email}}</router-link>
                </td>
                <td  style="vertical-align:middle">
                  {{crawl.started_at | moment('from')}}
                </td >
                <td  style="vertical-align:middle">
                  {{crawl.used_pages}}/{{crawl.max_pages}}
                </td>

                <td  style="vertical-align:middle">
                  {{crawl.status}} <span v-if="crawl.recurring_schedule">({{crawl.recurring_schedule[0]}})</span>
                </td>
                <td  style="vertical-align:middle">
                  <span :title="JSON.stringify(crawl.errors)">{{crawl.errors.length}}</span>
                </td>
                <td>
                  <a v-if="crawl.website.share_link" :href="`${VUE_APP_DOMAIN_ROOT}${crawl.website.share_link}/dashboard`" target="_blank" rel="noreferrer">View</a>
                  <a v-else href="#here" @click="shareLink(crawl.website)" rel="noreferrer">{{crawl.website.share_link || 'Generate'}}</a></td>
              </tr>
              </tbody>
            </table>
          </Widget>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget },
    data() {
      return {
        users: [],
        user_count: 0,
        crawl_count: 0,
        VUE_APP_DOMAIN_ROOT: process.env.VUE_APP_DOMAIN_ROOT,
        crawls: [],
        loading: true,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite'}),
    },
    methods: {
      getStats(){
        axios
                .get(`admin/stats`)
                .then(
                        response => {
                          this.loading = false;
                          this.users = response.data.users;
                          this.crawls = response.data.crawls;
                          this.user_count = response.data.user_count;
                          this.crawl_count = response.data.crawl_count;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
      shareLink(website){
        axios
                .post(`websites/share/${website.uuid}`)
                .then(
                        response => {
                          website.share_link = response.data.data.id;
                          return response.data.data.id;
                        },
                        _response => {
                          return false;
                        }
                );
      },
    },
    created() {
      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });
    },
    mounted() {
      this.getStats();
    }
  };
</script>

<style src="./CommandCenter.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
